import { render, staticRenderFns } from "./cardPermiso.vue?vue&type=template&id=d38c71c2&"
import script from "./cardPermiso.vue?vue&type=script&lang=js&"
export * from "./cardPermiso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports